import React from 'react';
import { observer } from 'mobx-react-lite';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { SpecialSportsForm } from './SpecialSportsForm/SpecialSportsForm';
import { SpecialSportsModelType } from 'src/api/config/special_sports/getSpecialSports';
import { SpecialSportsListItem } from './SpecialSportsList/SpecialSportsListItem';
import { ColumnOneOfTwo, MainContent, TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const SpecialSports = observer(() => {
    const { cmsState } = useAppStateContext();
    const { specialSportsList, isLoading } = cmsState.specialSportsState;

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={isLoading} data-test='special-sport-list'>
                        <Loader isActive={isLoading} />
                        {specialSportsList.map((specialSportsItem: SpecialSportsModelType) => {
                            return (
                                <SpecialSportsListItem
                                    key={specialSportsItem.id}
                                    specialSportsItem={specialSportsItem}
                                />
                            );
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <SpecialSportsForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
